import ClientSearchList from "./ClientSearchList";

export default ClientSearchList;